import axios from "axios";
import { Box, CircularProgress, Typography } from "@mui/material"; // Import MUI components for the loader

// Create an axios instance
const apiClient = axios.create({
  baseURL: "https://backendoasis.luknos.com/api",
  //baseURL: "http://192.168.1.121:4000/api",

  //baseURL: "http://ecogas.luknos.com/api",
  //baseURL: "http://192.168.1.24:4000/api",
});

apiClient.interceptors.request.use(
  (config) => {
    if (sessionStorage.getItem("token")) {
      const token = `Bearer ${sessionStorage.getItem("token")}`;
      console.log("token", token);

      // Add a timestamp to the request parameters to prevent caching
      // This ensures that the latest data is always fetched.
      config.params = {
        ...config.params,
        _t: Date.now(),
      };

      return {
        ...config,
        headers: {
          ...(token !== null && { Authorization: `${token}` }),
          ...config.headers,
        },
      };
    } else {
      window.location.href = "/";
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle global responses
apiClient.interceptors.response.use(
  (response) => {
    // Handle successful responses
    if (
      response.data.msg && // Check if msg exists to prevent errors
      (response.data.msg.message === "jwt expired" ||
        response.data.msg.message === "invalid signature" ||
        response.data.msg.message === "jwt malformed")
    )
      window.location.href = "/";
    return response;
  },
  (error) => {
    // Handle response errors
    if (error.response) {
      // The request was made and the server responded with a status code
      switch (error.response.status) {
        case 401:
          // Token is expired or invalid
          sessionStorage.removeItem("token"); // Clear the token
          window.location.href = "/"; // Redirect to login page
          break;
        case 403:
          // Forbidden (no access)
          console.error("Access forbidden:", error.response.data);
          break;
        case 404:
          // Not found
          console.error("Resource not found:", error.response.data);
          break;
        case 500:
          // Internal server error
          console.error("Server error:", error.response.data);
          break;
        default:
          console.error("An error occurred:", error.response.data);
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error("No response received:", error.request);
      // Using a custom message box instead of alert()
      // You would typically implement a Material-UI Dialog or Snackbar here
      // For demonstration, a simple console log is used, but in a real app,
      // you'd show a user-friendly modal.
      console.log(
        "No response received from the server. Please check your network connection or try again later."
      );
    } else {
      // Something happened in setting up the request
      console.error("Request setup error:", error.message);
    }
    return Promise.reject(error);
  }
);
// Define common API methods
const _get = (url, config = {}) => {
  return apiClient.get(url, config);
};

const _delete = (url, config = {}) => {
  return apiClient.delete(url, config);
};

const _put = (url, data = {}, config = {}) => {
  return apiClient.put(url, data, config);
};

const _post = (url, data = {}, config = {}) => {
  return apiClient.post(url, data, config);
};

// Loader function
const _getloader = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <CircularProgress size={60} color="primary" />
      <Typography variant="h6" mt={2}>
        Loading...
      </Typography>
    </Box>
  );
};

// Export API methods and loader
export { _get, _delete, _put, _post, _getloader };
